import React from 'react'
import Paper from '@mui/material/Paper';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, IconButton } from '@mui/material';
// import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import EditIcon from '@mui/icons-material/Edit';
import { Link } from "react-router-dom";

const columns = [
    { id: 'Address', label: 'Address',maxWidth:50},
    { id: 'EnglishText', label: 'English Text',maxWidth:50},
    { id: 'eventType', label: 'Event Type'},
    { id: 'relationDef', label: 'RelationDef'},
    { id: 'enable', label: 'Enable'},
    { id: 'actions', label: 'Actions' ,minWidth:150},
];

const EventsTable = ({
    page,
    rowsPerPage,
    mappingData,
    handleChangePage,
    handleChangeRowsPerPage
}) => {

    //const navigate = useNavigate();

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer className='TableVirtuoso' sx={{ maxHeight: "100vh" }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {mappingData?.data?.length > 0 ? mappingData?.data.map((row,i) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                                    {columns?.map((column) => {
                                        const value = row[column.id];
                                        //let addressArray = row?.Address.split('.');
                                        //let eventId = [...addressArray].pop();
                                        let eventId = row.Eid;
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {column?.format && typeof value === 'number'
                                                    ? column.format(value) 
                                                    : column.id === 'actions' ? 
                                                    <>  
                                                        {/* <IconButton 
                                                            color="inherit" 
                                                            title="View Event"
                                                            
                                                        >
                                                            <RemoveRedEyeIcon />
                                                        </IconButton> */}
                                                        {/* <Button color='primary' variant='contained' size="small" onClick={()=>{navigate(`/events/${row.id}/details`)}} >View More</Button> */}
                                                        <IconButton 
                                                            component={Link} 
                                                            color="inherit" 
                                                            title="Edit Event"
                                                            to="/events/edit"
                                                            state={{ eventId : eventId}}
                                                            //onClick={()=>{navigate(`/events/${row.id}/details`)}}
                                                            //onClick={()=> handleEditRow(row)}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>

                                                    </>
                                                    : value 
                                                }
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        }) : <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
            {mappingData?.total > 0  ? 
                <TablePagination
                    //rowsPerPageOptions={[100, 200, 500,{label:'ALL',value: -1}]}
                    rowsPerPageOptions={[100, 200, 500, 1000]}
                    component="div"
                    count={mappingData?.total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage} 
                   // labelDisplayedRows={({from,to,count}) => console.log('to',to)}
                />
                : <></>
            }
        </Paper> 
    )
}

export default EventsTable